/*---------------------------------------------------------------
 ?? Project: Ring2All Platform
 ????? Author: Rodrigo Cuadra
 ?? Company: Ring2All LLC
 ?? File: components\SystemVarsXmlModal.tsx
 ??? Created: 2026-05-02
 ?? Description:
    Implementation of the System Vars module.
----------------------------------------------------------------*/


import { Download } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { useI18n } from '../../../hooks/useI18n';

interface Props {
    xmlPreview: string;
    onClose: () => void;
    onDownload: () => void;
}

export function SystemVarsXmlModal({ xmlPreview, onClose, onDownload }: Props) {
    const { t } = useI18n();
    if (!xmlPreview) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-background rounded-lg p-6 max-w-4xl max-h-[80vh] overflow-auto">
                <div className="flex items-center justify-between mb-4">
                    <div>
                        <h3 className="text-lg font-semibold">{t('systemVars.xmlPreview.title')}</h3>
                        <p className="text-sm text-muted-foreground">{t('systemVars.xmlPreview.description')}</p>
                    </div>
                    <Button onClick={onClose} variant="ghost" size="sm">�</Button>
                </div>
                <pre className="bg-muted p-4 rounded text-sm overflow-auto">{xmlPreview}</pre>
                <div className="flex gap-2 mt-4">
                    <Button onClick={onDownload} size="sm">
                        <Download className="h-4 w-4 mr-2" />
                        {t('systemVars.buttons.downloadXml')}
                    </Button>
                    <Button onClick={onClose} variant="outline" size="sm">{t('common.close')}</Button>
                </div>
            </div>
        </div>
    );
}
